"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ConfirmationPage_1 = __importDefault(require("./ConfirmationPage"));
exports.default = ConfirmationPage_1.default;
//# sourceMappingURL=index.js.map